import Head from 'next/head';
import type { FC } from 'react';
import React from 'react';

type Props = {
  title?: string;
};

export const PageHead: FC<Props> = ({ title }) => (
  <Head>
    <meta name="robots" content="noindex,nofollow" />
    {title && <title>{title}</title>}
  </Head>
);
